import { Flex, Spinner } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { lazy, Suspense } from "react"

const TechnologyFlowEditorPage = lazy(
  () =>
    import(
      "../../../../../components/WMS/Technologies/Flows/TechnologyFlowEditorPage"
    ),
)

export const Route = createFileRoute("/_layout/WMS/technologies/flows/$flowId")(
  {
    component: LazyFlowEditorRoute,
  },
)

function LazyFlowEditorRoute() {
  const { flowId } = Route.useParams()

  return (
    <Suspense
      fallback={
        <Flex h="full" w="full" align="center" justify="center" py={12}>
          <Spinner size="lg" />
        </Flex>
      }
    >
      <TechnologyFlowEditorPage key={flowId} flowId={flowId} />
    </Suspense>
  )
}
